import { CanvasJSON, TRANSPARENT_PIXEL } from '@doer/frontend-components/creativity-editor';
import { PATH_URL } from '../../_shared/data/path-url';

export const hipotecarioBeneficios1080x1440: CanvasJSON = {
  version: '7.1.0',
  objects: [
    // background
    {
      type: 'Rect',
      version: '7.1.0',
      pieceId: 'background',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1440,
      fill: '#ffffff',
      selectable: false,
      evented: false,
      objectCaching: true
    },

    // benefit-category-image — imagen derivada de la categoría (computeDefaults + image-replace).
    // Cuadrado x:341 y:354 398x321 → centro (540, 514.5), contain.
    {
      type: 'Image',
      version: '7.1.0',
      pieceId: 'benefit-category-image',
      originX: 'center',
      originY: 'center',
      imageFit: 'contain',
      imageBox: { width: 370, height: 310 },
      left: 540,
      top: 555.5,
      width: 1,
      height: 1,
      scaleX: 398,
      scaleY: 321,
      cropX: 0,
      cropY: 0,
      src: TRANSPARENT_PIXEL,
      crossOrigin: 'anonymous',
      filters: [],
      selectable: true,
      evented: true,
      objectCaching: true
    },

    // discount-value-image — imagen del descuento derivada de discount-value (computeDefaults + image-replace).
    {
      type: 'Image',
      version: '7.1.0',
      pieceId: 'discount-value-image',
      originX: 'center',
      originY: 'center',
      imageFit: 'contain',
      imageBox: { width: 774, height: 191 },
      left: 540,
      top: 803.3249,
      width: 1,
      height: 1,
      scaleX: 746,
      scaleY: 191,
      cropX: 0,
      cropY: 0,
      src: TRANSPARENT_PIXEL,
      crossOrigin: 'anonymous',
      filters: [],
      selectable: true,
      evented: true,
      objectCaching: true
    },

    // benefit-category-pill — fondo de la pieza benefit-category.
    {
      type: 'Image',
      version: '7.1.0',
      pieceId: 'benefit-category-pill',
      src: `${PATH_URL}/beneficios/pill.png`,
      crossOrigin: null,
      filters: [],
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 260.5819,
      width: 773,
      height: 187,
      scaleX: 1.0056,
      scaleY: 1.0012,
      selectable: true,
      evented: true,
      objectCaching: true
    },

    // valid-days — "MARTES Y MIÉRCOLES" / "MIÉRCOLES"
    {
      type: 'Textbox',
      version: '7.1.0',
      pieceId: 'valid-days',
      text: 'LUNES',
      fontFamily: 'VAG Rounded',
      fontSize: 70,
      fontWeight: 300,
      fontStyle: 'normal',
      lineHeight: 1,
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      fill: '#616365',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 95.7435,
      width: 885,
      selectable: true,
      evented: true,
      objectCaching: true
    },

    // benefit-category — "Alimentos" / "Librerías" (autoFit sobre la pill)
    {
      type: 'Textbox',
      version: '7.1.0',
      pieceId: 'benefit-category',
      text: 'Supermercados',
      fontFamily: 'VAG Rounded',
      fontSize: 76,
      fontWeight: 700,
      fontStyle: 'normal',
      lineHeight: 1.16,
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      fill: 'rgb(255,255,255)',
      originX: 'center',
      // originY center en el centro de la pill (benefit-category-pill.top): el autofit
      // cambia el alto, pero anclado por el centro queda siempre centrado verticalmente.
      originY: 'center',
      left: 540,
      top: 260.5819,
      width: 592,
      autoFit: {
        minFontSize: 63,
        maxFontSize: 100,
        maxHeight: 104,
        snapTo: 1
      },
      selectable: true,
      evented: true,
      objectCaching: false
    },

    // participating-stores-text y monthly-cap viven en las variantes de stores-section
    // (data/stores-section-variants.ts); el polymorphic-binder monta la variante activa.

    // payment-method-text: sus piezas viven en las variantes (data/payment-method-variants.ts),
    // el polymorphic-binder las monta/desmonta según la variante elegida (card / modo).

    // legal-text
    {
      type: 'Textbox',
      version: '7.1.0',
      pieceId: 'legal-text',
      text: 'Válido desde el 05/08/2026 al 30/08/2026. Publicidad. Cartera de Consumo.\nPara más información o limitaciones aplicables consulte en\nhttp://www.hipotecario.com.ar.',
      fontFamily: 'VAG Rounded',
      fontSize: 29,
      fontWeight: 300,
      fontStyle: 'normal',
      lineHeight: 0.85,
      charSpacing: 0,
      textAlign: 'center',
      // URL en chars 131–163 (constante con fechas DD/MM/YYYY de ancho fijo).
      styles: [
        {
          start: 131,
          end: 163,
          style: {
            fill: '#fd7708',
            fontWeight: 'bold'
          }
        }
      ],
      fill: '#616365',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1382.4886,
      width: 966.0228,
      selectable: true,
      evented: true,
      objectCaching: true
    }
  ],
  background: 'transparent'
};
